import { Calculator } from './calc';
import type { Converter } from './types';
import './print';

interface WindowWithConverters extends Window {
  __CONVERTERS__?: Record<string, Converter>;
}

document.querySelectorAll<HTMLElement>('.tool-page').forEach(el => {
  const slug = el.dataset.toolSlug;
  if (!slug) return;
  const converter = (window as WindowWithConverters).__CONVERTERS__?.[slug];
  if (!converter) {
    console.warn(`No converter data for ${slug}`);
    return;
  }
  new Calculator(el, converter).init();
});

if (document.querySelector('.katex[data-latex]')) {
  import('./katex-init');
}
